<template>
    <div class="solution-summary pb-2">
        <b-card no-body v-if="insurance_draft_products.length > 0">
            <b-card-header header-bg-variant="primary" header-class="p-2 text-white">
                Insurance
            </b-card-header>
            <b-card-body class="px-4 py-2">
                <b-row class="mb-3 pt-2" v-for="(product, index) in insurance_draft_products" :key="index">
                    <b-col cols="12" md="3" class="border-right d-flex align-items-center">
                        <div class="text-center w-100">
                            <h3>{{ product.product_detail.prod_ins_company }}</h3>
                            <!-- <el-image
                                class="rounded mr-2"
                                src="https://download.logo.wine/logo/Manulife/Manulife-Logo.wine.png"
                                fit="cover"
                            ></el-image> -->
                        </div>
                    </b-col>
                    <b-col cols="12" md="9">
                        <b-row>
                            <b-col cols="12" md="4">
                                <b-form-group label="Type">
                                    <div class="bg-muted rounded-lg py-2 px-2">
                                        <p v-if="product.product_detail.prod_ins_type === 'INVESTMENT_LINK'">Investment Link</p>
                                        <p v-if="product.product_detail.prod_ins_type === 'LIFE_INSURANCE'">Life Insurance</p>
                                    </div>
                                    <!-- <el-select v-model="product.product_detail.prod_ins_type" placeholder="Select" disabled>
                                        <el-option
                                            v-for="(item, index) in productOptions"
                                            :key="index"
                                            :label="item.text"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select> -->
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Package">
                                    <b-form-input
                                        v-model="product.product_detail.prod_ins_package"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Premium p.a">
                                    <b-form-input
                                        v-model="product.product_detail.prod_ins_premium_pa"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Premium p.m">
                                    <b-form-input
                                        v-model="product.product_detail.prod_ins_premium_pm"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Premium cover">
                                    <b-form-input
                                        v-model="product.product_detail.prod_ins_premium_cover"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Paid By">
                                    <b-form-input
                                        v-model="product.product_detail.prod_ins_paid_by"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mx-auto mt-1 pb-1">
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex justify-content-end align-items-center">
                                    <div>
                                        <el-button class="bg-success py-2 text-white" 
                                          @click="convertProductToCaseHandler(product.prod_id)" 
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">CONVERT TO CASE</small>
                                        </el-button>
                                          <el-button class="bg-danger py-2 text-white" 
                                          @click="removeProductHandler(product)"
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">REMOVE</small>
                                        </el-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <div class="text-center mt-5" v-else>No draft found.</div>
    </div>
</template>
<script>
import { Image, Button, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'

export default {
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        CurrencyInput,
        [Image.name]: Image,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed:{
        ...mapState(useProductStore, ['insurance_draft_products']),
    },
    data() {
        return {
            is_loading: {
                case: false,
                value: ''
            },
            productOptions: [
                { text: 'Investment Link', value: 'INVESTMENT_LINK' },
                { text: 'Life Insurance', value: 'LIFE_INSURANCE' }
            ],
        }
    },
    methods:{
        ...mapActions(useProductStore, ['removeProduct', 'convertProductToCase']),
        ...mapActions(useNotificationStore, ['fetchEmailTemplate']),
        ...mapActions(useMessagingStore, ['sendEmail']),
        resetIsLoading(){
            this.is_loading.case = false
            this.is_loading.value = null
        },
        async convertProductToCaseHandler(id){
            this.is_loading.case = true
            this.is_loading.value = id
            try{
                await this.convertProductToCase(id, 'insurance')
                await this.sendCaseApprovalEmail(id)
                
                this.resetIsLoading()
                if(this.checkAppCode('sas')){
                    this.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
                }else{
                    this.notifySuccess('<b>Case Successfully Created </b>')
                }
            }catch(e){
                this.errorFunction(e)
                this.resetIsLoading()
                return
            }
        },
        async sendCaseApprovalEmail(id) {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {
            const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

            // Prepare the email data
            const emailData = {
                to: recipients,
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                    .replace('{case_id}', id) // Replace {case_id} with product ID
            };

              await this.sendEmail(emailData);
              this.notifySuccess('Email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        async removeProductHandler(product){
            this.is_loading.case = true
            this.is_loading.value = product.prod_id
            try{
                await this.removeProduct(product)
                this.notifySuccess('<b>Draft </b> - Successfully Removed.')
                this.resetIsLoading()
            }catch(e){
                this.resetIsLoading()
                this.errorFunction(null, e)
            }
        }
    }
}
</script>